import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgreementsPwa = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#9575CD' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='m23.893 14.03-2.386-2.385c-.9-.9-2.137-.855-2.745.113l-1.327 2.1 4.253 4.252 2.1-1.327c.907-.578.96-1.905.104-2.753'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='m21.688 18.103.18 3.09c.172 1.725-.428 2.325-2.063 2.52l-6.54.772c-1.38.158-2.37-.832-2.205-2.205l.735-6.21M17.435 13.858l-1.312-.083M11.96 23.585l2.385-2.393'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M16.25 12.875c0 .307-.045.615-.128.9a3.34 3.34 0 0 1-1.027 1.635 3.33 3.33 0 0 1-2.22.84 3.2 3.2 0 0 1-1.08-.18 3.35 3.35 0 0 1-1.807-1.455 3.4 3.4 0 0 1-.488-1.74c0-1.065.488-2.017 1.268-2.633a3.37 3.37 0 0 1 5.483 2.633M12.89 14.135v-2.52M14.12 12.875H11.6'
    />
  </svg>
);
export default SvgAgreementsPwa;
